import { DispatchWithoutAction, memo } from 'react';

import { Link } from 'react-router-dom';
import { FiMenu } from 'react-icons/fi';

import { useAuth, useEventfy } from '@hooks';
import { Avatar } from '@components';
import { selectUser } from '@hooks/useAuth/selectors';
import { IndicationsIllustration } from '@assets';

import * as S from './styles';

type HeaderProps = {
  onMobileMenuClick?: DispatchWithoutAction;
  onUserClick?: DispatchWithoutAction;
  onIndicationsClick?: DispatchWithoutAction;
  languageSelector?: React.ReactNode;
  userDropdown?: React.ReactNode;
};

export const Header = ({
  onMobileMenuClick,
  onUserClick,
  onIndicationsClick,
  languageSelector,
  userDropdown,
}: HeaderProps) => {
  const { name, logo, indication } = useEventfy();
  const user = useAuth(selectUser);

  return (
    <S.HeaderContainer>
      <S.LeftSection>
        {onMobileMenuClick && (
          <S.MobileMenuButton type="button" onClick={onMobileMenuClick}>
            <FiMenu size={24} />
          </S.MobileMenuButton>
        )}

        <Link to="/lobby">
          <S.LogoWrapper>
            {logo ? (
              <S.LogoImage src={logo} alt={name} />
            ) : (
              <S.LogoIcon>E</S.LogoIcon>
            )}
          </S.LogoWrapper>
        </Link>
      </S.LeftSection>

      <S.RightSection>
        {!!indication && onIndicationsClick && (
          <S.IndicationsButton type="button" onClick={onIndicationsClick}>
            <IndicationsIllustration />
          </S.IndicationsButton>
        )}

        {languageSelector}

        {userDropdown || (
          <S.UserButton type="button" onClick={onUserClick}>
            <Avatar src={user.avatar} alt={user.name} />
            <S.UserName>{user.name}</S.UserName>
          </S.UserButton>
        )}
      </S.RightSection>
    </S.HeaderContainer>
  );
};

export default memo(Header);
